var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loadingAction } },
    [
      _vm.selectedAuctions.length > 1
        ? _c(
            "b-dropdown",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED221",
                  expression: "'ED221'"
                }
              ],
              attrs: {
                variant: "link",
                "no-caret": "",
                "data-cy": "massive-actions",
                right: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "button-content",
                    fn: function() {
                      return [
                        _c("feather-icon", {
                          staticClass: "mr-3",
                          attrs: { icon: "ApertureIcon" }
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v("Acciones")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                609182883
              )
            },
            [
              _c(
                "CheckPermission",
                { attrs: { permission: "ED224" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-prepare" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAuctionPrepare()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "arrow_forward" } }),
                      _vm._v(" Preparar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED227" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-un-prepare" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAuctionUnPrepare()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "arrow_back" } }),
                      _vm._v(" Dejar de preparar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED229" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-publish" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAuctionPublish()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "verified_user" } }),
                      _vm._v(" Publicar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED222" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-cancel" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAuctionCancel()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "clear" } }),
                      _vm._v(" Cancelar ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "CheckPermission",
                { attrs: { permission: "ED223" } },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "data-cy": "massive-end" },
                      on: {
                        click: function($event) {
                          return _vm.onOptionAuctionEnd()
                        }
                      }
                    },
                    [
                      _c("vs-icon", { attrs: { icon: "check_circle" } }),
                      _vm._v(" Finalizar ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }